import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=48407882&scoped=true&lang=pug&"
import script from "./StatusIndicator.vue?vue&type=script&lang=ts&"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=48407882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48407882",
  null
  
)

export default component.exports